import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotsVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0001 11.3333C10.4603 11.3333 10.8334 10.9602 10.8334 10.5C10.8334 10.0398 10.4603 9.66666 10.0001 9.66666C9.53984 9.66666 9.16675 10.0398 9.16675 10.5C9.16675 10.9602 9.53984 11.3333 10.0001 11.3333Z",
			stroke: "#A3A3A3",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0001 5.49999C10.4603 5.49999 10.8334 5.1269 10.8334 4.66666C10.8334 4.20642 10.4603 3.83333 10.0001 3.83333C9.53984 3.83333 9.16675 4.20642 9.16675 4.66666C9.16675 5.1269 9.53984 5.49999 10.0001 5.49999Z",
			stroke: "#A3A3A3",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0001 17.1667C10.4603 17.1667 10.8334 16.7936 10.8334 16.3333C10.8334 15.8731 10.4603 15.5 10.0001 15.5C9.53984 15.5 9.16675 15.8731 9.16675 16.3333C9.16675 16.7936 9.53984 17.1667 10.0001 17.1667Z",
			stroke: "#A3A3A3",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDotsVertical;
